module.exports = __webpack_public_path__ + "static/media/view-icon.c6d411a6.svg";